module.exports = __webpack_public_path__ + "static/media/cover-image-top.be65f7da.png";